<template>
  <div

    v-b-popover.hover.html="hoverTxt"
    title="Andons"
    >
    &nbsp
  </div>
</template>
<script>

import {Steps} from '../../core/services/steps.js'

export default {
  name: 'GenericAndonCard',
  props: ['items'],
  data() {
    return {
      stepList: Steps
    };
  },
  methods: {
    displayRef(reference) {
      return this.chunk(reference, 3).join(' ')
    },
    chunk(str, n) {
      var ret = [];
      var i;
      var len;
      for(i = 0, len = str.length; i < len; i += n) {
        ret.push(str.substr(i, n))
      }
      return ret
    },
    displayDate (dateStr) {
      let splitStr = dateStr.split(' ')
      let date = splitStr[0].split('-')

      return date.reverse().join('/') + ' '+splitStr[1].slice(0,5)
    }
  },
  computed: {
    hoverTxt: function () {
      let hoverTxtArray = []
      this.items.forEach((item, index) => {
        let hoverTxt = '<b>'
        switch (item.type) {
          case 'low_stock':
            hoverTxt += 'STOCK FAIBLE<br>' + item.andon.card_in_stock + ' / ' + item.andon.card_in_total + '<br>'
            hoverTxt += '</b>'
            hoverTxt += this.displayRef(item.andon.kanban_id)
            hoverTxt += '<br>(' + item.andon.kanban_reference.reference.designation + ')' +'<br>'
            break
          case 'bad_erp_stock':
            hoverTxt += 'ECART STOCK<br>' + item.andon.kanban_stock + ' / ' + item.andon.erp_stock + '<br>'
            hoverTxt += '</b>'
            hoverTxt += this.displayRef(item.andon.kanban_id)
            hoverTxt += '<br>(' + item.andon.kanban_reference.reference.designation + ')' +'<br>'
            break
          case 'unseen':
            hoverTxt += 'RETARD<br>'
            hoverTxt += '</b>'
            hoverTxt += this.displayRef(item.andon.kanban_id)
            hoverTxt += '<br>(' + item.andon.kanban_card.kanban_reference.reference.designation + ')' +'<br>'
            break
          case 'fifo':
            hoverTxt += 'FIFO<br>'
            hoverTxt += 'Vu' + item.andon.andon_scan.kanban_card.card_id + '(' + item.andon.andon_scan.kanban_card.card_index + '/' + item.andon.andon_scan.kanban_card.kanban_reference.nbr_card + '<br>'
            hoverTxt += 'Préc.' + item.andon.previous_scan.kanban_card.card_id + '(' + item.andon.previous_scan.kanban_card.card_index + '/' + item.andon.andon_scan.kanban_card.kanban_reference.nbr_card + '<br>'
            hoverTxt += 'Station: ' + this.stepList[item.andon.andon_scan.workstation.name]['display'] + '<br>'
            hoverTxt += '</b>'
            hoverTxt += this.displayRef(item.andon.kanban_id)
            hoverTxt += '<br>(' + (item.andon.designation ? item.andon.designation : item.andon.andon_scan.kanban_card.kanban_reference.reference.designation) + ')' +'<br>'
            break
        }
        
        hoverTxt += '<br>' + 'Créé le: ' + this.displayDate(item.andon.base.created_at) + '<br>'
        let timeLeft = Math.max(Date.parse(item.andon.base.time_to_next_andon) - Date.now(), 0)
        hoverTxt += '<br>Temps restant: '
        if (timeLeft > 3600 * 1000 * 24) {
          let days = Math.floor(timeLeft / (3600 * 1000 * 24))
          timeLeft -= days * 3600 * 1000 * 24
          hoverTxt += String(days) + 'j '
        }
        if (timeLeft > 3600 * 1000) {
          let hours = Math.floor(timeLeft / (1000 * 3600))
          timeLeft -= 3600 * 1000 * hours
          hoverTxt += String(hours) + 'h '
        }
        if (timeLeft > 60 * 1000) {
          let mins = Math.floor(timeLeft / (60 * 1000))
          hoverTxt += String(mins) + 'min.'
        }
        else {
          hoverTxt += '0 min.'
        }

        hoverTxtArray.push(hoverTxt)
      })

      return hoverTxtArray.join('<hr/>')
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/andon/GenericAndonCard.vue